/*
 * SR QuickPay v8.1
 * - v6.5 全部改动：邮箱清空取消会员 + _initReady 回填 + f_hideCartTools
 * - CDN 缓存问题：换文件名彻底解决
 * - TODO: 修复空邮箱不应触发 "Please enter a valid email" 报错
 */


(function() {
  'use strict';

  // ============================================================
  // 前置检查
  // ============================================================

  if (typeof SRCartCtrl === 'undefined') {
    console.error('[SR QuickPay v8.1] SRCartCtrl not found. sr-cart-ctrl.js must load first.');
    return;
  }

  // ============================================================
  // 状态变量（仅 UI 状态）
  // ============================================================

  var _uiTimer = null;
  var _updatingUI = false;
  var srElementsReady = false;
  var _drawerInjected = false;
  var _drawerWasOpen = false;
  var _lineItemRetryCount = 0;
  var _LINE_ITEM_MAX_RETRIES = 3;
  var _initReady = null;

  // ============================================================
  // 工具函数（View 层专用）
  // ============================================================

  function f_safe(fn) { try { fn(); } catch(e) {} }

  function f_isValidEmail(e) { return e && e.indexOf('@') > 0 && e.lastIndexOf('@') < e.length - 1; }

  function f_formatPrice(cents) { return (cents / 100).toFixed(2); }

  function f_getCartData() { return fetch('/cart.js').then(function(r) { return r.json(); }); }

  function f_getCurrentEmail() {
    var input = document.getElementById('sr_addr_email');
    var v = input ? input.value.trim().toLowerCase() : '';
    if (!v || v.indexOf('@') <= 0) {
      var memberData = SRController.get();
      v = memberData.email || '';
    }
    return v;
  }

  function f_getCurrentMid() {
    return SRController.get().mid || '';
  }

  // ============================================================
  // 初始化
  // ============================================================

  function f_init() {
    if (window.self !== window.top) return;

    // 初始化 Cart Controller（异步）
    _initReady = SRCartCtrl.init();

    // 新会话购物车清空后，强制刷新 T4S 抽屉 UI
    _initReady.then(function() {
      // 邮箱同步：每次 init 完成后，会员 email 必须显示在输入框
      var emailInput = document.getElementById('sr_addr_email');
      if (emailInput) {
        var md = SRController.get();
        if (md.email) emailInput.value = md.email;
      }

      var sessionKey = 'sr_init_cart_refreshed';
      if (sessionStorage.getItem(sessionKey)) return;
      sessionStorage.setItem(sessionKey, '1');

      return f_getCartData().then(function(cart) {
        if (cart.items && cart.items.length === 0) {
          // 清空抽屉中的商品行
          var selectors = [
            '.t4s-cart-items .t4s-cart-item',
            '.t4s-cart-items > div:not(.t4s-when-cart-emty)',
            '[data-cart-items] > div:not(.t4s-when-cart-emty)'
          ];
          for (var i = 0; i < selectors.length; i++) {
            var els = document.querySelectorAll(selectors[i]);
            for (var j = 0; j < els.length; j++) {
              els[j].style.display = 'none';
            }
          }
          // 显示"购物车为空"提示
          var emptyEls = document.querySelectorAll('.t4s-when-cart-emty');
          for (var k = 0; k < emptyEls.length; k++) {
            emptyEls[k].style.cssText = '';
          }
          // 更新角标
          var badges = document.querySelectorAll('.t4s-cart-count, .t4s-cart__count, [data-cart-count]');
          for (var m = 0; m < badges.length; m++) {
            badges[m].textContent = '0';
            badges[m].style.display = 'none';
          }
          console.log('[SR QuickPay] Cart cleared, drawer UI refreshed');
        }
      });
    }).catch(function() {});

    // 注册事件监听
    document.addEventListener('sr:member-changed', f_onMemberChanged);
    document.addEventListener('visibilitychange', f_onVisibilityChange);
    window.addEventListener('pageshow', f_onPageShow);

    // 启动 UI 监控
    f_safe(f_hideRecommendations);
    f_safe(f_hideBuyItNowButtons);
    f_safe(f_hideCartTools);
    f_handlePayPalReturn();
    f_watchDrawer(f_onDrawerChange);
    f_interceptCartAPI(f_onCartAdd);
  }

  // ============================================================
  // M2. 邮箱/手机输入处理
  // ============================================================

  function f_setupContactInputHandler() {
    var emailInput = document.getElementById('sr_addr_email');
    var phoneInput = document.getElementById('sr_addr_phone');

    if (emailInput) {
      var confirmBtn = document.getElementById('sr_email_confirm');
      if (confirmBtn) {
        confirmBtn.addEventListener('click', function() {
          var v = emailInput.value.trim().toLowerCase();
          var hint = document.getElementById('sr_addr_email_hint');

          // 邮箱清空 → 取消会员身份（沙盒内）
          if (v === '') {
            SRController.cart.save({ email: '', mid: '' });
            SRCartCtrl.updateCustomer({ email: '' });
            f_safe(f_updateCartUI);
            if (hint) { hint.textContent = ''; hint.style.color = '#999'; }
            return;
          }

          if (f_isValidEmail(v)) {
            // 保存旧值用于失败回滚
            var prevEmail = emailInput.value;
            var prevMemberData = SRController.get();
            // 调用 setEmail 写入 localStorage（购物车工作态），同时从 KV 拉取会员数据
            confirmBtn.disabled = true;
            confirmBtn.textContent = '...';
            SRController.setEmail(v, { writeToLocalStorage: true })
              .then(function(memberData) {
                // 同步沙盒和购买域
                SRController.cart.save({ email: v });
                SRCartCtrl.updateCustomer({ email: v });
                // 刷新 UI（地址列表会自动从 localStorage 加载）
                f_safe(f_updateCartUI);
                if (hint) {
                  hint.textContent = memberData.mid ? 'Member ✓' : 'Email saved ✓';
                  hint.style.color = '#451A00';
                }
              })
              .catch(function(err) {
                console.warn('[SR QuickPay] setEmail failed:', err);
                var msg = (err && err.message) ? err.message : 'Something went wrong';
                // 友好错误映射
                if (/invalid email|email.*invalid|not a valid/i.test(msg)) msg = 'This email address is not valid. Please check and try again.';
                else if (/already registered/i.test(msg)) msg = 'This email is already in use by another account.';
                else if (/network|fetch|timeout/i.test(msg)) msg = 'Network error. Please check your connection and try again.';
                // 回滚 UI 到旧邮箱
                emailInput.value = prevEmail;
                SRController.cart.save({ email: prevEmail });
                if (hint) { hint.textContent = msg; hint.style.color = '#e74c3c'; }
                else if (typeof window.SRModal !== 'undefined') { window.SRModal.error('Error', msg); }
              })
              .finally(function() {
                confirmBtn.disabled = false;
                confirmBtn.textContent = 'Confirm';
              });
          } else {
            if (hint) { hint.textContent = 'Please enter a valid email address'; hint.style.color = '#e74c3c'; }
          }
        });
      }

      emailInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (confirmBtn) confirmBtn.click();
        }
      });
    }

    if (phoneInput) {
      phoneInput.addEventListener('input', function() {
        var v = this.value.trim();
        // 抽屉内只写沙盒，不碰全局状态
        SRController.cart.save({ phone: v });
        SRCartCtrl.updateCustomer({ phone: v });
      });

      // 从 Controller 恢复
      if (!phoneInput.value) {
        var memberData = SRController.get();
        phoneInput.value = memberData.phone || '';
      }
    }
  }

  // ============================================================
  // M3. 弹窗 UI
  // ============================================================

  function f_showRequiredFieldsModal() {
    var overlay = document.createElement('div');
    overlay.id = 'sr-required-modal-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.4);z-index:99999;display:flex;align-items:center;justify-content:center;';
    overlay.innerHTML = '<div style="position:relative;background:#FDFBF7;border:1px solid #e0d5c1;border-radius:12px;padding:28px 24px 20px;max-width:400px;width:90%;box-shadow:0 8px 32px rgba(0,0,0,0.15);font-family:inherit;">' +
      '<button type="button" onclick="var o=document.getElementById(\'sr-required-modal-overlay\');if(o&&o.parentNode)o.parentNode.removeChild(o);" style="position:absolute;top:10px;right:14px;background:none;border:none;font-size:20px;color:#999;cursor:pointer;line-height:1;padding:4px 8px;">&times;</button>' +
      '<div style="font-size:17px;font-weight:600;color:#451A00;margin-bottom:16px;text-align:center;">Required Information</div>' +
      '<div style="font-size:14px;color:#666;line-height:1.8;margin-bottom:20px;">' +
        'Please fill in the following required fields before continuing:<br>' +
        '<strong style="color:#e74c3c">\u2022 Email address</strong>' +
      '</div>' +
      '<button type="button" onclick="var o=document.getElementById(\'sr-required-modal-overlay\');if(o&&o.parentNode)o.parentNode.removeChild(o);" style="width:100%;padding:14px;background:#451A00;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer;transition:opacity .15s;text-align:center;">OK</button>' +
    '</div>';
    document.body.appendChild(overlay);
  }

  function f_showEmailMismatchModal(formEmail, cookieEmail, existingMember) {
    return new Promise(function(resolve) {
      // 此弹窗只在 formEmail 属于其他已注册会员时弹出
      // 未注册的 email 在 Confirm 时已直接替换，不会触发此弹窗
      var overlay = document.createElement('div');
      overlay.id = 'sr-email-modal-overlay';
      overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.4);z-index:99999;display:flex;align-items:center;justify-content:center;';
      overlay.innerHTML = '<div style="position:relative;background:#FDFBF7;border:1px solid #e0d5c1;border-radius:12px;padding:28px 24px 20px;max-width:400px;width:90%;box-shadow:0 8px 32px rgba(0,0,0,0.15);font-family:inherit;">' +
        '<div style="font-size:17px;font-weight:600;color:#451A00;margin-bottom:16px;text-align:center;">Existing Account Found</div>' +
        '<div style="font-size:13px;color:#666;line-height:1.8;margin-bottom:16px;text-align:center;">' +
          'The email <strong style="color:#451A00">' + formEmail + '</strong> is already registered as an Insider account.<br>' +
          'Please verify to switch.' +
          '</div>' +
        '<div style="background:#f9f5ee;border:1px solid #e8dcc8;border-radius:8px;padding:14px;margin-bottom:20px;font-size:13px;color:#666;line-height:1.9;">' +
          '<div style="display:flex;align-items:center;gap:8px;">' +
            '<span style="color:#888;min-width:70px;">Current</span>' +
            '<strong style="color:#451A00;word-break:break-all;">' + cookieEmail + '</strong>' +
          '</div>' +
          '<div style="display:flex;align-items:center;gap:8px;margin-top:4px;">' +
            '<span style="color:#888;min-width:70px;">Target</span>' +
            '<strong style="color:#451A00;word-break:break-all;">' + formEmail + '</strong>' +
          '</div>' +
        '</div>' +
        '<div style="display:flex;flex-direction:column;gap:10px;">' +
          '<button id="sr-modal-verify" type="button" style="padding:14px;background:#451A00;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer;transition:opacity .15s;text-align:center;">Send verification code</button>' +
          '<button id="sr-modal-cancel" type="button" style="padding:10px;background:none;border:none;color:#555;font-size:13px;cursor:pointer;margin-top:4px;">Never mind</button>' +
        '</div>' +
      '</div>';
      document.body.appendChild(overlay);

      function closeModal() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }

      function onEsc(e) {
        if (e.key === 'Escape') {
          document.removeEventListener('keydown', onEsc);
          closeModal();
          resolve(false);
        }
      }
      document.addEventListener('keydown', onEsc);

      var verifyBtn = document.getElementById('sr-modal-verify');
      var cancelBtn = document.getElementById('sr-modal-cancel');

      verifyBtn.onmouseover = function() { verifyBtn.style.opacity = '0.85'; };
      verifyBtn.onmouseout = function() { verifyBtn.style.opacity = '1'; };

      verifyBtn.onclick = function() {
        closeModal();
        // v8.1: 统一走 processEmailInput（preConfirmed=true → 409 时走 OTP）
        SRController.processEmailInput(formEmail, { writeToLocalStorage: true, preConfirmed: true }).then(function(memberData) {
          // 更新 DOM 中的 email input
          var emailInput = document.getElementById('sr_addr_email');
          if (emailInput) emailInput.value = formEmail;
          resolve(formEmail);
        }).catch(function(err) {
          console.error('[SR v8.1] processEmailInput for account switch failed:', err);
          window.SRModal.error('Unable to switch account', (err && err.message) ? err.message : 'Please try again.');
          resolve(false);
        });
      };

      cancelBtn.onclick = function() {
        closeModal();
        var emailInput = document.getElementById('sr_addr_email');
        if (emailInput) emailInput.value = cookieEmail;
        // 清除 sandbox 中的 email 变更
        SRController.cart.save({ email: cookieEmail });
        resolve(cookieEmail);
      };
    });
  }

  function f_showCouponInvalidModal(code, error) {
    var overlay = document.createElement('div');
    overlay.id = 'sr-coupon-modal-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.4);z-index:99999;display:flex;align-items:center;justify-content:center;';
    overlay.innerHTML = '<div style="position:relative;background:#FDFBF7;border:1px solid #e0d5c1;border-radius:12px;padding:28px 24px 20px;max-width:400px;width:90%;box-shadow:0 8px 32px rgba(0,0,0,0.15);font-family:inherit;">' +
      '<button type="button" onclick="var o=document.getElementById(\'sr-coupon-modal-overlay\');if(o&&o.parentNode)o.parentNode.removeChild(o);" style="position:absolute;top:10px;right:14px;background:none;border:none;font-size:20px;color:#999;cursor:pointer;line-height:1;padding:4px 8px;">&times;</button>' +
      '<div style="font-size:17px;font-weight:600;color:#e74c3c;margin-bottom:16px;text-align:center;">Invalid Coupon</div>' +
      '<div style="font-size:14px;color:#666;line-height:1.8;margin-bottom:20px;">' +
        'The coupon code <strong style="color:#451A00">"' + code + '"</strong> could not be applied.<br>' +
        '<span style="font-size:12px;color:#999">Reason: ' + (error || 'Not applicable') + '</span>' +
      '</div>' +
      '<button type="button" onclick="var o=document.getElementById(\'sr-coupon-modal-overlay\');if(o&&o.parentNode)o.parentNode.removeChild(o);" style="width:100%;padding:14px;background:#451A00;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer;transition:opacity .15s;text-align:center;">OK</button>' +
    '</div>';
    document.body.appendChild(overlay);

    function onEsc(e) {
      if (e.key === 'Escape') {
        document.removeEventListener('keydown', onEsc);
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }
    }
    document.addEventListener('keydown', onEsc);
  }

  function f_showEmailChangePrompt(newEmail, oldEmail) {
    var overlay = document.createElement('div');
    overlay.id = 'sr-email-change-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.4);z-index:99999;display:flex;align-items:center;justify-content:center;';
    overlay.innerHTML = '<div style="position:relative;background:#FDFBF7;border:1px solid #e0d5c1;border-radius:12px;padding:28px 24px 20px;max-width:400px;width:90%;box-shadow:0 8px 32px rgba(0,0,0,0.15);font-family:inherit;">' +
      '<div style="font-size:17px;font-weight:600;color:#451A00;margin-bottom:16px;text-align:center;">Email Change</div>' +
      '<div style="background:#f9f5ee;border:1px solid #e8dcc8;border-radius:8px;padding:14px;margin-bottom:20px;font-size:13px;color:#666;line-height:1.9;">' +
        '<div style="display:flex;align-items:center;gap:8px;">' +
          '<span style="color:#888;min-width:50px;">Current</span>' +
          '<strong style="color:#451A00;word-break:break-all;">' + oldEmail + '</strong>' +
        '</div>' +
        '<div style="display:flex;align-items:center;gap:8px;margin-top:4px;">' +
          '<span style="color:#888;min-width:50px;">New</span>' +
          '<strong style="color:#451A00;word-break:break-all;">' + newEmail + '</strong>' +
        '</div>' +
      '</div>' +
      '<div style="display:flex;flex-direction:column;gap:10px;">' +
        '<button id="sr-email-update" type="button" style="padding:14px;background:#451A00;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer;text-align:center;">Update my email</button>' +
        '<button id="sr-email-keep" type="button" style="padding:10px;background:none;border:none;color:#555;font-size:13px;cursor:pointer;">Keep current email</button>' +
      '</div>' +
    '</div>';
    document.body.appendChild(overlay);

    function closeModal() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }

    document.getElementById('sr-email-update').onclick = function() {
      closeModal();
      SRController.setEmail(newEmail).catch(function(err) {
        console.warn('[SR v8.1] setEmail in change prompt failed:', err);
        SRController.update({ email: newEmail });
      });
      SRCartCtrl.updateCustomer({ email: newEmail });
    };

    document.getElementById('sr-email-keep').onclick = function() {
      closeModal();
      var emailInput = document.getElementById('sr_addr_email');
      if (emailInput) emailInput.value = oldEmail;
    };
  }

  // ============================================================
  // 地址辅助函数（UI 层）
  // ============================================================

  function f_updateSummary(addr) {
    var summary = document.getElementById('sr-addr-summary');
    if (summary && addr) {
      summary.textContent = addr.first_name + ' ' + addr.last_name + ' \u00b7 ' + addr.city + ', ' + (addr.state || '') + ' ' + addr.zip;
    }
  }

  function f_fillFormFields(addr) {
    if (!addr) return;
    var fields = {
      sr_addr_first: addr.first_name || '',
      sr_addr_last: addr.last_name || '',
      sr_addr_line1: addr.address1 || '',
      sr_addr_line2: addr.address2 || '',
      sr_addr_city: addr.city || '',
      sr_addr_state: addr.state || '',
      sr_addr_zip: addr.zip || '',
      sr_addr_phone: addr.phone || '',
      sr_addr_country: addr.country || 'US'
    };
    for (var id in fields) {
      var el = document.getElementById(id);
      if (el) el.value = fields[id];
    }
    var defCb = document.getElementById('sr_addr_default');
    if (defCb) defCb.checked = addr.is_default !== false;
  }

  function f_showAddressForm(addr) {
    var form = document.getElementById('sr-addr-form');
    var title = document.getElementById('sr-form-title');
    if (!form) return;

    if (addr) {
      title.textContent = 'Edit Address';
      document.getElementById('sr_addr_save').setAttribute('data-edit-id', addr.id || '');
      f_fillFormFields(addr);
    } else {
      title.textContent = 'New Address';
      document.getElementById('sr_addr_save').removeAttribute('data-edit-id');
      f_fillFormFields({ first_name: '', last_name: '', address1: '', address2: '', city: '', state: '', zip: '', phone: '', country: 'US' });
      document.getElementById('sr_addr_default').checked = false;
    }
    form.style.display = 'block';
    form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function f_renderAddressList(addrs, email) {
    var listEl = document.getElementById('sr-addr-list');
    if (!listEl) return;

    if (!addrs || addrs.length === 0) {
      listEl.innerHTML = '<div style="font-size:12px;color:#999;text-align:center;padding:8px 0">No saved addresses yet</div>';
      return;
    }

    var html = '';
    for (var i = 0; i < addrs.length; i++) {
      var a = addrs[i];
      var isSelected = a.is_default;
      var borderStyle = isSelected ? 'border-color:#451A00;background:rgba(69,26,0,0.03)' : 'border-color:#e8ddd0';

      html += '<div class="sr-addr-card" data-idx="' + i + '" style="padding:10px;border:1px solid ' + (isSelected ? '#451A00' : '#e8ddd0') + ';border-radius:6px;margin-bottom:8px;cursor:pointer;transition:all .15s;position:relative;' + (isSelected ? 'background:rgba(69,26,0,0.03)' : '') + '">' +
        '<div style="display:flex;align-items:center;gap:6px;margin-bottom:3px">' +
          '<span style="font-size:10px;color:#8B7355;font-weight:500;text-transform:uppercase;letter-spacing:.5px">' + (a.label || 'Other') + '</span>' +
          (a.is_default ? '<span style="font-size:9px;background:#451A00;color:#fff;padding:1px 5px;border-radius:3px;letter-spacing:.5px">DEFAULT</span>' : '') +
        '</div>' +
        '<div style="font-size:13px;color:#451A00;font-weight:500">' + a.first_name + ' ' + a.last_name + '</div>' +
        '<div style="font-size:12px;color:#5a4a3a;line-height:1.4">' +
          a.address1 + (a.address2 ? ', ' + a.address2 : '') + '<br>' +
          a.city + ', ' + (a.state || '') + ' ' + a.zip +
        '</div>' +
        '<div class="sr-addr-actions" style="position:absolute;top:8px;right:8px;display:flex;gap:4px;opacity:0;transition:opacity .15s">' +
          '<button type="button" class="sr-card-edit" data-idx="' + i + '" style="padding:3px 7px;background:#f0f0f0;color:#666;border:none;border-radius:3px;font-size:11px;cursor:pointer">Edit</button>' +
          (addrs.length > 1 ? '<button type="button" class="sr-card-delete" data-idx="' + i + '" data-id="' + (a.id || '') + '" style="padding:3px 7px;background:#fde8e8;color:#e74c3c;border:none;border-radius:3px;font-size:11px;cursor:pointer">Delete</button>' : '') +
        '</div>' +
      '</div>';
    }
    listEl.innerHTML = html;

    // 绑定卡片事件
    var cards = listEl.querySelectorAll('.sr-addr-card');
    for (var j = 0; j < cards.length; j++) {
      (function(card) {
        card.addEventListener('mouseenter', function() {
          var actions = this.querySelector('.sr-addr-actions');
          if (actions) actions.style.opacity = '1';
          if (!this.style.background || this.style.background.indexOf('rgba(69') === -1) {
            this.style.background = 'rgba(69,26,0,0.02)';
          }
        });
        card.addEventListener('mouseleave', function() {
          var actions = this.querySelector('.sr-addr-actions');
          if (actions) actions.style.opacity = '0';
        });
        card.addEventListener('click', function(e) {
          if (e.target.classList.contains('sr-card-edit') || e.target.classList.contains('sr-card-delete')) return;
          var idx = parseInt(this.getAttribute('data-idx'));
          f_selectAddress(idx);
        });
      })(cards[j]);
    }

    // Edit 按钮
    var editBtns = listEl.querySelectorAll('.sr-card-edit');
    for (var k = 0; k < editBtns.length; k++) {
      editBtns[k].addEventListener('click', function(e) {
        e.stopPropagation();
        var idx = parseInt(this.getAttribute('data-idx'));
        var addr = SRCartCtrl.getAddresses()[idx];
        if (addr) f_showAddressForm(addr);
      });
    }

    // Delete 按钮
    var delBtns = listEl.querySelectorAll('.sr-card-delete');
    for (var m = 0; m < delBtns.length; m++) {
      delBtns[m].addEventListener('click', function(e) {
        e.stopPropagation();
        var idx = parseInt(this.getAttribute('data-idx'));

        if (!confirm('Delete this address?')) return;

        var localAddrs = SRCartCtrl.getAddresses();
        if (idx < localAddrs.length) {
          localAddrs.splice(idx, 1);
          SRCartCtrl.saveAddresses(localAddrs);
          if (SRCartCtrl.getDefaultIdx() >= localAddrs.length) SRCartCtrl.setDefaultIdx(0);
        }

        // 重新渲染
        f_renderAddressList(SRCartCtrl.getAddresses(), f_getCurrentMid());
        var remaining = SRCartCtrl.getAddresses();
        if (remaining.length > 0) {
          f_updateSummary(remaining[0]);
        }
      });
    }
  }

  function f_selectAddress(idx) {
    var addrs = SRCartCtrl.getAddresses();
    var addr = addrs[idx];
    if (!addr) return;

    f_fillFormFields(addr);
    f_updateSummary(addr);

    // 更新卡片选中状态
    var cards = document.querySelectorAll('.sr-addr-card');
    for (var i = 0; i < cards.length; i++) {
      if (i === idx) {
        cards[i].style.borderColor = '#451A00';
        cards[i].style.background = 'rgba(69,26,0,0.03)';
      } else {
        cards[i].style.borderColor = '#e8ddd0';
        cards[i].style.background = '';
      }
    }

    SRCartCtrl.setDefaultIdx(idx);

    // 折叠面板
    var panel = document.getElementById('sr-addr-panel');
    var arrow = document.getElementById('sr-addr-arrow');
    if (panel) panel.style.display = 'none';
    if (arrow) arrow.style.transform = 'rotate(0deg)';
  }

  function f_updateShippingEstimate() {
    var el = document.getElementById('sr_shipping_content');
    if (!el) return;

    var addr = SRCartCtrl.getSavedAddress();
    if (!addr) {
      el.innerHTML =
        '<p style="margin:0;font-size:12px;color:#999">Set a shipping address first to get estimates.</p>' +
        '<button type="button" id="sr_shipping_set_addr" style="margin-top:8px;padding:5px 12px;background:#8B4513;color:#fff;border:none;border-radius:4px;font-size:12px;cursor:pointer">Set Address</button>';
      var setAddrBtn = document.getElementById('sr_shipping_set_addr');
      if (setAddrBtn) {
        setAddrBtn.addEventListener('click', function() {
          var toggle = document.getElementById('sr-addr-toggle');
          if (toggle) toggle.click();
        });
      }
      return;
    }

    var state = (addr.state || '').toUpperCase();
    var freeStates = 'CA OR WA NV AZ UT CO NM TX OK KS NE SD ND MT WY ID HI AK'.split(' ');
    var eastStates = 'NY NJ CT MA RI VT NH ME PA DE MD VA WV NC SC GA FL DC AL MS TN KY OH MI IN IL WI MN IA MO AR LA'.split(' ');

    var estimate = '$5.99';
    var note = '';

    if (addr.country && addr.country !== 'US') {
      estimate = '$12.99';
      note = '(International: ' + addr.country + ')';
    } else if (freeStates.indexOf(state) !== -1) {
      estimate = 'FREE';
      note = '(Free shipping to ' + state + ')';
    } else if (eastStates.indexOf(state) !== -1) {
      estimate = '$5.99';
      note = '(East Coast rate)';
    } else if (state) {
      estimate = '$7.99';
      note = '(Standard rate)';
    }

    el.innerHTML =
      '<div style="font-size:12px;color:#666;margin-bottom:4px">Ship to ' + addr.city + ', ' + (addr.state || '') + ':</div>' +
      '<div style="display:flex;align-items:baseline;gap:6px">' +
        '<span style="font-size:18px;font-weight:700;color:#8B4513">' + estimate + '</span>' +
        '<span style="font-size:11px;color:#999">' + note + '</span>' +
      '</div>' +
      '<p style="margin:6px 0 0;font-size:11px;color:#aaa">Final shipping calculated at checkout</p>';
  }

  // ============================================================
  // M5. 购物车 UI 渲染
  // ============================================================

  function f_dedupDiscountElements() {
    var all = Array.prototype.slice.call(
      document.querySelectorAll('#sr-insider-discount-info, .sr-line-insider-price, [data-sr-discount-info]')
    );
    var infoFound = false;
    var priceFound = {};
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.id === 'sr-insider-discount-info') {
        if (infoFound) { el.remove(); continue; }
        infoFound = true;
      }
      if (el.classList.contains('sr-line-insider-price')) {
        var parentKey = el.parentNode ? el.parentNode.getAttribute('data-line-key') || el.parentNode.innerHTML.substring(0, 50) : i;
        if (priceFound[parentKey]) { el.remove(); continue; }
        priceFound[parentKey] = true;
      }
    }
  }

  function f_updateCartUI() {
    if (_uiTimer) clearTimeout(_uiTimer);
    _uiTimer = setTimeout(f_doUpdateCartUI, 200);
  }

  function f_doUpdateCartUI() {
    if (_updatingUI) {
      if (_uiTimer) clearTimeout(_uiTimer);
      _uiTimer = setTimeout(f_doUpdateCartUI, 100);
      return;
    }
    _updatingUI = true;

    // 单向同步: SRController → 购买域
    SRCartCtrl.syncCustomerFromController();

    var isMember = SRController.isMember();
    var discounted = SRCartCtrl.applyDiscountToProducts();

    var bottom = document.querySelector('.t4s-drawer__bottom');
    if (!bottom) { _updatingUI = false; return; }

    f_dedupDiscountElements();

    // 找 T4S 原生的 subtotal 元素
    var subtotalEl = null;
    var children = bottom.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].id && children[i].id.indexOf('sr-') === 0) continue;
      if (children[i].classList.contains('t4s-cart-total')) {
        subtotalEl = children[i];
        break;
      }
      var text = (children[i].textContent || '').trim();
      if (/subtotal/i.test(text) && /\$[\d,.]+/.test(text)) {
        subtotalEl = children[i];
        break;
      }
    }
    if (!subtotalEl) { _updatingUI = false; return; }

    // 写 Subtotal 价格
    if (discounted) {
      var originalCents = discounted.originalTotal;
      var finalCents = discounted.finalTotal;
      var subHtml = 'Subtotal: ';
      if (originalCents > finalCents) {
        subHtml += '<span style="text-decoration:line-through;color:#999;font-size:12px">$' + f_formatPrice(originalCents) + '</span> ';
        subHtml += '<strong>$' + f_formatPrice(finalCents) + '</strong> USD';
      } else {
        subHtml += '<strong>$' + f_formatPrice(finalCents) + '</strong> USD';
      }
      subtotalEl.innerHTML = subHtml;
    } else {
      f_getCartData().then(function(cart) {
        if (cart && cart.total_price > 0) {
          subtotalEl.innerHTML = 'Subtotal: <strong>$' + f_formatPrice(cart.total_price) + '</strong> USD';
        } else {
          subtotalEl.innerHTML = '';
        }
      });
    }

    // 写折扣公式行
    var info = document.getElementById('sr-insider-discount-info');
    if (!info) {
      info = document.createElement('div');
      info.id = 'sr-insider-discount-info';
      info.setAttribute('data-sr-discount-info', '1');
      info.style.cssText = 'margin-top:4px;font-size:13px;color:#b8860b;padding:2px 0;';
      subtotalEl.parentNode.insertBefore(info, subtotalEl.nextSibling);
    }
    var dr = discounted ? discounted.discountResult : null;
    if (dr && dr.formula) {
      info.innerHTML = '<span style="font-size:12px"><b>' + dr.formula + '</b></span>';
    } else {
      info.innerHTML = '';
    }

    // 刷新商品行 Insider 单价
    f_updateLineItemInsiderPrice();

    _updatingUI = false;
  }

  function f_updateLineItemInsiderPrice() {
    var isMember = SRController.isMember();
    var coupon = SRCartCtrl.getCoupon();
    if (!isMember && !coupon.code) {
      _lineItemRetryCount = 0;
      return;
    }

    var dr = SRCartCtrl.calculateDiscount(isMember, coupon.rate);

    var cartItems = document.querySelectorAll('.t4s-cart-item, [class*="cart-item"]');

    if (cartItems.length === 0 && _lineItemRetryCount < _LINE_ITEM_MAX_RETRIES) {
      _lineItemRetryCount++;
      setTimeout(f_updateLineItemInsiderPrice, 500);
      return;
    }
    _lineItemRetryCount = 0;

    for (var i = 0; i < cartItems.length; i++) {
      var item = cartItems[i];
      if (item.id && item.id.indexOf('sr-') === 0) continue;

      var priceEls = item.querySelectorAll('[class*="price"], .money, [class*="money"]');
      if (!priceEls.length) continue;

      var priceEl = priceEls[0];
      var priceText = (priceEl.textContent || '').trim();
      var priceMatch = priceText.match(/\$?([\d,]+\.?\d*)/);
      if (!priceMatch) continue;

      var listedPrice = parseFloat(priceMatch[1].replace(/,/g, ''));
      if (isNaN(listedPrice) || listedPrice <= 0) continue;

      var finalPrice = (listedPrice * (1 - dr.discountRate)).toFixed(2);

      var existingInsider = item.querySelector('.sr-line-insider-price');
      if (!existingInsider) {
        existingInsider = document.createElement('div');
        existingInsider.className = 'sr-line-insider-price';
        existingInsider.setAttribute('data-sr-discount-info', '1');
        existingInsider.style.cssText = 'font-size:12px;color:#b8860b;margin-top:2px;';
        priceEl.parentNode.insertBefore(existingInsider, priceEl.nextSibling);
      }

      existingInsider.innerHTML =
        '<span style="text-decoration:line-through;color:#999;font-size:11px">$' + listedPrice.toFixed(2) + '</span> ' +
        '<span style="font-weight:600">$' + finalPrice + '</span>';
    }
  }

  // ============================================================
  // Coupon 应用（View 层 — 负责 UI 反馈）
  // ============================================================

  function f_handleApplyCoupon(code) {
    var msgEl = document.getElementById('sr_discount_msg');
    if (!code) {
      var coupon = SRCartCtrl.getCoupon();
      if (coupon.code) {
        if (msgEl) { msgEl.textContent = 'Removing...'; msgEl.style.color = '#999'; }
        SRCartCtrl.removeCoupon().then(function(ok) {
          if (ok) {
            if (msgEl) { msgEl.textContent = 'Coupon removed.'; msgEl.style.color = '#999'; }
            setTimeout(function() { f_safe(f_updateCartUI); }, 800);
          }
        });
      } else {
        if (msgEl) { msgEl.textContent = ''; msgEl.style.color = '#999'; }
      }
      return;
    }
    if (msgEl) { msgEl.textContent = 'Applying...'; msgEl.style.color = '#999'; }
    SRCartCtrl.applyCoupon(code).then(function(result) {
      if (result.valid) {
        if (msgEl) {
          msgEl.textContent = 'Discount applied!';
          msgEl.style.color = '#27ae60';
        }
        setTimeout(function() { f_safe(f_updateCartUI); }, 800);
      } else {
        f_showCouponInvalidModal(code, result.error);
        if (msgEl) { msgEl.textContent = 'Invalid code.'; msgEl.style.color = '#e74c3c'; }
      }
    });
  }

  // ============================================================
  // M10. 抽屉监控
  // ============================================================

  function f_watchDrawer(callback) {
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class') {
          var isOpen = document.body.classList.contains('is--opend-drawer');
          callback(isOpen);
        }
      }
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    return observer;
  }

  // ============================================================
  // 核心修复 — 抽屉关闭统一流程
  // ============================================================

  var _injectRetryTimer = null;

  function f_tryInjectWithRetry(maxRetries) {
    if (_injectRetryTimer) clearTimeout(_injectRetryTimer);
    var attempt = 0;
    function tryOnce() {
      // 检查抽屉是否还开着
      if (!document.body.classList.contains('is--opend-drawer')) return;
      // 检查购买域是否存在
      if (!SRCartCtrl.getCustomer()) {
        // 购买域还没就绪，等 ctrl_init 完成
        if (attempt < maxRetries) {
          attempt++;
          _injectRetryTimer = setTimeout(tryOnce, 500);
        }
        return;
      }
      var injected = f_injectAllIntoDrawer();
      if (injected) {
        f_safe(f_updateCartUI);
        _drawerInjected = true;
      } else if (attempt < maxRetries) {
        // 注入失败（抽屉可能还没渲染完），重试
        attempt++;
        _injectRetryTimer = setTimeout(tryOnce, 500);
      }
    }
    tryOnce();
  }

  function f_onDrawerChange(isOpen) {
    // 抽屉打开
    if (isOpen && !_drawerWasOpen) {
      f_onDrawerOpen();
    }

    // 抽屉关闭 → 调 SRCartCtrl 统一关闭流程
    if (!isOpen && _drawerWasOpen) {
      console.log('[SR v8.1] Drawer closed, running unified close flow...');
      if (_injectRetryTimer) clearTimeout(_injectRetryTimer);
      f_onCartClose();
    }

    // 注入 UI（如果抽屉打开 + 尚未注入）
    if (isOpen && !_drawerInjected) {
      // 首次延迟 300ms，然后最多重试 5 次（每次 500ms）
      setTimeout(function() {
        f_tryInjectWithRetry(5);
      }, 300);
    }

    // 抽屉关闭时重置注入标记
    if (!isOpen) {
      _drawerInjected = false;
    }

    _drawerWasOpen = isOpen;
  }

  function f_onDrawerOpen() {
    SRController.cart.open();
  }

  function f_onCartClose() {
    // 调 cart-ctrl 的统一关闭流程（v1.2：lookup 已在 CartCtrl 完成）
    SRCartCtrl.handleDrawerClose({
      onEmailChanged: function(prevEmail, newEmail, existingMember) {
        // v8.1: 统一走 processEmailInput，由 Controller 内部判断 409 走 lightBoardLogin 还是冲突处理
        return SRController.processEmailInput(newEmail, { writeToLocalStorage: true })
          .then(function() {
            return newEmail;
          })
          .catch(function(err) {
            if (err && err.message === 'REQUIRES_CONFIRMATION') {
              // 有 MID 的已登录用户切换账号 → 需要确认弹窗
              return f_showEmailMismatchModal(newEmail, prevEmail, existingMember);
            }
            console.error('[SR v8.1] onCartClose processEmailInput error:', err);
            return false;
          });
      }
    }).then(function() {
      // 关闭后刷新 UI
      f_updateCartUI();
      var memberData = SRController.get();
      console.log('[SR v8.1] Drawer closed:', JSON.stringify({
        mid: memberData.mid,
        email: memberData.email,
        isMember: SRController.isMember(),
        joined: memberData.joined
      }));
    });
  }

  // ============================================================
  // fetch 拦截（购物车内容变化监控）
  // ============================================================

  function f_interceptCartAPI(callback) {
    var _originalFetch = window.fetch;
    if (!_originalFetch) return;
    window.fetch = function() {
      var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
      var result = _originalFetch.apply(this, arguments);
      if (url && (String(url).indexOf('/cart/change.js') !== -1 ||
                  String(url).indexOf('/cart/update.js') !== -1 ||
                  String(url).indexOf('/cart/add.js') !== -1)) {
        result.then(function() { callback(); });
      }
      return result;
    };
  }

  function f_onCartAdd() {
    f_getCartData().then(function(cart) {
      if (!cart.items || cart.items.length === 0) return;
      if (!SRCartCtrl.getCustomer()) {
        SRCartCtrl.createPurchaseDomain(cart);
      } else {
        SRCartCtrl.syncProductsFromCart(cart);
      }
      f_safe(f_injectAllIntoDrawer);
      f_safe(f_updateCartUI);
      setTimeout(function() { f_safe(f_updateCartUI); }, 500);
    });
  }

  // ============================================================
  // UI 注入
  // ============================================================

  function f_hideRecommendations() {
    if (!document.getElementById('sr-hide-upsell')) {
      var style = document.createElement('style');
      style.id = 'sr-hide-upsell';
      style.textContent = [
        '[data-cart-upsell-options], [data-cart-upsell-options] * { display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important; }'
      ].join('\n');
      document.head.appendChild(style);
    }
    var upsells = document.querySelectorAll('[data-cart-upsell-options]');
    for (var i = 0; i < upsells.length; i++) {
      upsells[i].style.display = 'none';
    }
  }

  function f_hideBuyItNowButtons() {
    if (document.getElementById('sr-hide-bin')) return;
    var style = document.createElement('style');
    style.id = 'sr-hide-bin';
    style.textContent = [
      '.shopify-payment-button, .shopify-payment-button__button, .shopify-payment-button__more-options { display: none !important; }',
      '.t4s-buy-now, [data-buy-now], button[data-type="buy-it-now"], .t4s-product-buy-now { display: none !important; }',
      'button[class*="buy-now" i], a[class*="buy-now" i], [class*="dynamic-checkout" i] { display: none !important; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  // v6.5: 隐藏 T4S 默认购物车工具栏（Order Note / Shipping / Coupon 三图标）
  // 原因：这些图标在 [data-cart-tools] 容器中，带 t4s-when-cart-emty 类名，
  // v6.4 移除了 .t4s-when-cart-emty 的永久隐藏后导致图标露出
  function f_hideCartTools() {
    if (document.getElementById('sr-hide-tools')) return;
    var style = document.createElement('style');
    style.id = 'sr-hide-tools';
    style.textContent = '[data-cart-tools] { display: none !important; }';
    document.head.appendChild(style);
  }

  function f_takeoverDrawerBottom() {
    if (!srElementsReady) return;

    var bottom = document.querySelector('.t4s-drawer__bottom') ||
                 document.querySelector('[class*="drawer"] [class*="bottom"]') ||
                 document.querySelector('[class*="cart-drawer"] [class*="footer"]');
    if (!bottom) return;

    var children = bottom.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child.id && child.id.indexOf('sr-') === 0) continue;
      if (child.classList.contains('t4s-cart-total')) continue;
      child.style.setProperty('display', 'none', 'important');
    }
    f_hideIconButtonsInDrawer();
  }

  function f_hideIconButtonsInDrawer() {
    var bottom = document.querySelector('.t4s-drawer__bottom');
    if (!bottom) return;

    var buttons = bottom.querySelectorAll('button');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.id && btn.id.indexOf('sr-') === 0) continue;
      if (btn.closest && btn.closest('[id^="sr-"]')) continue;
      if (btn.name === 'checkout') continue;

      var text = (btn.textContent || '').trim().toUpperCase();
      if (text.indexOf('ORDER NOTE') !== -1 || text.indexOf('ESTIMATE SHIPPING') !== -1 ||
          text.indexOf('ADD A COUPON') !== -1 || text.indexOf('COUPON CODE') !== -1 ||
          text === 'NOTE' || text === 'SHIPPING' || text === 'COUPON') {
        btn.style.setProperty('display', 'none', 'important');
      }
    }

    var allEls = bottom.querySelectorAll('p, span, div, label');
    for (var j = 0; j < allEls.length; j++) {
      var el = allEls[j];
      if (el.id && el.id.indexOf('sr-') === 0) continue;
      if (el.closest && el.closest('[id^="sr-"]')) continue;

      var directText = '';
      for (var n = 0; n < el.childNodes.length; n++) {
        if (el.childNodes[n].nodeType === 3) directText += el.childNodes[n].textContent;
      }
      directText = directText.trim();

      if (/^taxes.*shipping/i.test(directText) || /^shipping.*calculated/i.test(directText)) {
        el.style.setProperty('display', 'none', 'important');
      }
    }
  }

  function f_createQuickPayButton(bottom) {
    if (document.getElementById('sr-quick-pay-btn')) return true;
    if (!bottom) return false;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'sr-quick-pay-btn';
    btn.innerHTML = 'Quick Pay';
    btn.style.cssText = 'display:block;width:100%;margin-top:10px;padding:14px 20px;background:#FFC439;color:#111;border:none;border-radius:4px;font-size:15px;font-weight:700;cursor:pointer;letter-spacing:.02em;transition:background .15s;text-align:center;box-sizing:border-box;';
    btn.onmouseover = function() { btn.style.background = '#F5BB2A'; };
    btn.onmouseout = function() { btn.style.background = '#FFC439'; };
    btn.addEventListener('click', function(e) { e.preventDefault(); f_handleQuickPay(); });
    bottom.appendChild(btn);
    return true;
  }

  function f_injectSRToolPanel(bottom) {
    if (document.getElementById('sr-tool-panel')) return;
    if (!bottom) return;

    var coupon = SRCartCtrl.getCoupon();

    var panel = document.createElement('div');
    panel.id = 'sr-tool-panel';
    panel.style.cssText = 'margin:10px 0;border:1px solid #e0d5c1;border-radius:8px;overflow:hidden;font-size:13px;box-sizing:border-box;';

    panel.innerHTML =
      '<div id="sr-tool-tabs" style="display:flex;border-bottom:1px solid #e0d5c1">' +
        '<button type="button" class="sr-tool-tab" data-panel="note" style="flex:1;padding:10px 4px;background:none;border:none;font-size:11px;color:#8B4513;cursor:pointer;text-align:center">Order Note</button>' +
        '<button type="button" class="sr-tool-tab" data-panel="shipping" style="flex:1;padding:10px 4px;background:none;border:none;font-size:11px;color:#8B4513;cursor:pointer;text-align:center;border-left:1px solid #e0d5c1">Shipping</button>' +
        '<button type="button" class="sr-tool-tab" data-panel="coupon" style="flex:1;padding:10px 4px;background:none;border:none;font-size:11px;color:#8B4513;cursor:pointer;text-align:center;border-left:1px solid #e0d5c1">Coupon</button>' +
      '</div>' +
      '<div id="sr-panel-note" style="display:none;padding:10px 12px">' +
        '<textarea id="sr_order_note" placeholder="Add a note to your order..." style="width:100%;height:60px;padding:7px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px;box-sizing:border-box;resize:vertical;font-family:inherit"></textarea>' +
        '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:6px">' +
          '<span style="font-size:11px;color:#999">Note saved locally</span>' +
          '<button type="button" id="sr_note_save" style="padding:5px 12px;background:#8B4513;color:#fff;border:none;border-radius:4px;font-size:12px;cursor:pointer">Save</button>' +
        '</div>' +
      '</div>' +
      '<div id="sr-panel-shipping" style="display:none;padding:10px 12px">' +
        '<div id="sr_shipping_content"></div>' +
      '</div>' +
      '<div id="sr-panel-coupon" style="display:none;padding:10px 12px">' +
        '<div style="display:flex;gap:6px">' +
          '<input id="sr_discount_code" placeholder="Enter discount code" value="' + (coupon.code || '') + '" style="flex:1;padding:7px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px;box-sizing:border-box;min-width:0">' +
          '<button id="sr_discount_apply" type="button" style="padding:7px 14px;background:#8B4513;color:#fff;border:none;border-radius:4px;font-size:13px;cursor:pointer;white-space:nowrap">Apply</button>' +
        '</div>' +
        '<div id="sr_discount_msg" style="margin-top:4px;font-size:12px;min-height:16px"></div>' +
      '</div>';

    var qpBtn = document.getElementById('sr-quick-pay-btn');
    if (qpBtn && qpBtn.parentNode) {
      qpBtn.parentNode.insertBefore(panel, qpBtn);
    } else {
      bottom.appendChild(panel);
    }

    // Tab 切换
    var tabs = panel.querySelectorAll('.sr-tool-tab');
    var panelMap = {
      note: document.getElementById('sr-panel-note'),
      shipping: document.getElementById('sr-panel-shipping'),
      coupon: document.getElementById('sr-panel-coupon')
    };
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function() {
        var target = this.getAttribute('data-panel');
        for (var key in panelMap) {
          panelMap[key].style.display = (key === target) ? 'block' : 'none';
        }
        for (var j = 0; j < tabs.length; j++) {
          tabs[j].style.background = (tabs[j] === this) ? '#f5efe6' : 'none';
          tabs[j].style.fontWeight = (tabs[j] === this) ? '600' : '400';
        }
        if (target === 'shipping') f_updateShippingEstimate();
      });
    }

    // Note 保存
    var noteSaveBtn = document.getElementById('sr_note_save');
    if (noteSaveBtn) {
      noteSaveBtn.addEventListener('click', function() {
        var note = document.getElementById('sr_order_note').value;
        try { localStorage.setItem('sr_order_note', note); } catch(e) {}
        noteSaveBtn.textContent = 'Saved!';
        setTimeout(function() { noteSaveBtn.textContent = 'Save'; }, 1500);
      });
    }

    // 恢复已保存的 note
    var noteEl = document.getElementById('sr_order_note');
    if (noteEl) {
      try { noteEl.value = localStorage.getItem('sr_order_note') || ''; } catch(e) {}
    }

    // Coupon 应用
    var applyBtn = document.getElementById('sr_discount_apply');
    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        var code = document.getElementById('sr_discount_code').value.trim();
        var ready = _initReady || Promise.resolve();
        ready.then(function() {
          f_handleApplyCoupon(code);
        });
      });
    }
  }

  function f_injectContinueShopping(bottom) {
    if (document.getElementById('sr-continue-shopping')) return;
    if (!bottom) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'sr-continue-shopping';
    btn.textContent = 'Continue Shopping';
    btn.style.cssText = 'display:block;width:100%;margin-top:12px;padding:12px 20px;background:transparent;color:#8B4513;border:1px solid #8B4513;border-radius:4px;font-size:14px;font-weight:600;cursor:pointer;text-align:center;transition:all .15s;box-sizing:border-box;';
    btn.onmouseover = function() { btn.style.background = '#8B4513'; btn.style.color = '#fff'; };
    btn.onmouseout = function() { btn.style.background = 'transparent'; btn.style.color = '#8B4513'; };

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      e.stopImmediatePropagation();

      var drawer = document.getElementById('t4s-mini_cart');
      if (drawer) {
        drawer.classList.add('t4s-dn');
        drawer.classList.remove('t4s-drawer--active', 'is-open', 'open');
      }
      document.body.classList.remove('t4s-body-overflow-hidden');
      document.body.style.overflow = '';
      var overlays = document.querySelectorAll('.t4s-drawer__overlay, .t4s-overlay, [class*="drawer"][class*="overlay"]');
      for (var i = 0; i < overlays.length; i++) {
        overlays[i].classList.add('t4s-dn');
        overlays[i].style.display = 'none';
      }

      setTimeout(function() {
        window.location.href = '/collections/all';
      }, 150);
    }, true);

    bottom.appendChild(btn);
  }

  function f_injectAddressSection(bottom) {
    if (document.getElementById('sr-address-section')) return;
    if (!bottom) return;

    if (!document.getElementById('sr-placeholder-style')) {
      var ps = document.createElement('style');
      ps.id = 'sr-placeholder-style';
      ps.textContent = '#sr-address-section input::placeholder, #sr-address-section textarea::placeholder, #sr-tool-panel input::placeholder, #sr-tool-panel textarea::placeholder { color: #bbb !important; opacity: 1 !important; -webkit-text-fill-color: #bbb !important; }';
      document.head.appendChild(ps);
    }

    var saved = SRCartCtrl.getSavedAddress();
    var summaryText = saved
      ? ('Shipping: ' + saved.first_name + ' ' + saved.last_name + ' \u00b7 ' + saved.city + ', ' + (saved.state || '') + ' ' + saved.zip).trim()
      : 'Shipping address (click to set)';

    var section = document.createElement('div');
    section.id = 'sr-address-section';
    section.style.cssText = 'margin:10px 0;padding:10px 12px;border:1px solid #e0d5c1;border-radius:8px;font-size:13px;box-sizing:border-box;';

    // Email 输入区
    var memberData = SRController.get();
    var savedEmail = memberData.email || '';
    var isMember = SRController.isMember();
    var emailHtml =
      '<div style="margin-bottom:8px">' +
        '<label style="display:block;font-size:11px;color:#888;margin-bottom:3px">Email' + (isMember ? '' : ' <span style="color:#e74c3c">*</span>') + '</label>' +
        '<div style="display:flex;gap:6px">' +
          '<input id="sr_addr_email" type="email" placeholder="your@email.com" value="' + savedEmail + '" style="flex:1;padding:7px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px;box-sizing:border-box">' +
          '<button id="sr_email_confirm" type="button" style="padding:7px 14px;background:#451A00;color:#fff;border:none;border-radius:4px;font-size:13px;cursor:pointer;white-space:nowrap">Confirm</button>' +
        '</div>' +
        '<div id="sr_addr_email_hint" style="font-size:11px;color:#999;margin-top:2px"></div>' +
      '</div>';

    // 折叠状态：地址摘要
    var toggleHtml =
      '<div id="sr-addr-toggle" style="cursor:pointer;display:flex;align-items:center;gap:6px;color:#8B4513;font-weight:600">' +
        '<span style="font-size:10px;transition:transform .2s" id="sr-addr-arrow">&#9654;</span>' +
        '<span id="sr-addr-summary" style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:400">' + summaryText + '</span>' +
        (saved ? '<span id="sr-addr-default-badge" style="font-size:10px;background:#451A00;color:#fff;padding:2px 6px;border-radius:3px;letter-spacing:.5px">DEFAULT</span>' : '') +
      '</div>';

    // 展开面板：地址列表 + 表单
    var panelHtml =
      '<div id="sr-addr-panel" style="display:none;margin-top:10px;max-height:320px;overflow-y:auto">' +
        '<div id="sr-addr-list"></div>' +
        '<button id="sr-addr-new-btn" type="button" style="width:100%;padding:9px;border:1px dashed #c4a882;border-radius:6px;background:transparent;color:#8B7355;font-size:13px;cursor:pointer;margin-bottom:8px;transition:all .15s">+ Add New Address</button>' +
        '<div id="sr-addr-form" style="display:none;padding:10px;border:1px solid #e0d5c1;border-radius:6px;background:#fafafa">' +
          '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">' +
            '<span id="sr-form-title" style="font-size:13px;color:#451A00;font-weight:500">New Address</span>' +
            '<span id="sr-form-close" style="cursor:pointer;font-size:16px;color:#8B7355;padding:0 4px">&#10005;</span>' +
          '</div>' +
          '<div style="display:flex;gap:6px;margin-bottom:6px">' +
            '<input id="sr_addr_first" placeholder="First Name" style="flex:1;padding:7px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px;box-sizing:border-box;min-width:0">' +
            '<input id="sr_addr_last" placeholder="Last Name" style="flex:1;padding:7px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px;box-sizing:border-box;min-width:0">' +
          '</div>' +
          '<input id="sr_addr_line1" placeholder="Address" style="width:100%;margin-bottom:6px;padding:7px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px;box-sizing:border-box">' +
          '<input id="sr_addr_line2" placeholder="Apt, suite (optional)" style="width:100%;margin-bottom:6px;padding:7px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px;box-sizing:border-box">' +
          '<div style="display:flex;gap:6px;margin-bottom:6px">' +
            '<input id="sr_addr_city" placeholder="City" style="flex:1;padding:7px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px;box-sizing:border-box;min-width:0">' +
            '<input id="sr_addr_state" placeholder="State" style="flex:1;padding:7px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px;box-sizing:border-box;min-width:0">' +
            '<input id="sr_addr_zip" placeholder="ZIP" style="width:70px;padding:7px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px;box-sizing:border-box">' +
          '</div>' +
          '<select id="sr_addr_country" style="width:100%;margin-bottom:6px;padding:7px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px;box-sizing:border-box">' +
            '<option value="US">United States</option>' +
            '<option value="CA">Canada</option>' +
            '<option value="GB">United Kingdom</option>' +
            '<option value="AU">Australia</option>' +
            '<option value="DE">Germany</option>' +
            '<option value="FR">France</option>' +
            '<option value="JP">Japan</option>' +
            '<option value="CN">China</option>' +
          '</select>' +
          '<input id="sr_addr_phone" placeholder="Phone (optional)" style="width:100%;margin-bottom:6px;padding:7px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px;box-sizing:border-box">' +
          '<label style="display:flex;align-items:center;gap:6px;margin-bottom:8px;font-size:12px;color:#666;cursor:pointer">' +
            '<input type="checkbox" id="sr_addr_default" style="margin:0">' +
            '<span>Save as default address</span>' +
          '</label>' +
          '<div style="display:flex;gap:6px">' +
            '<button id="sr_addr_save" type="button" style="flex:1;padding:7px;background:#451A00;color:#fff;border:none;border-radius:4px;font-size:13px;cursor:pointer">Save</button>' +
            '<button id="sr_addr_cancel" type="button" style="flex:1;padding:7px;background:#f0f0f0;color:#666;border:none;border-radius:4px;font-size:13px;cursor:pointer">Cancel</button>' +
          '</div>' +
        '</div>' +
        '<div id="sr-addr-sync-status" style="font-size:11px;color:#8B7355;text-align:center;margin-top:6px;font-style:italic"></div>' +
      '</div>';

    section.innerHTML = emailHtml + toggleHtml + panelHtml;

    var qpBtn = document.getElementById('sr-quick-pay-btn');
    if (qpBtn && qpBtn.parentNode) {
      qpBtn.parentNode.insertBefore(section, qpBtn);
    } else {
      bottom.appendChild(section);
    }

    // --- 事件绑定 ---

    // 折叠/展开
    var toggleEl = document.getElementById('sr-addr-toggle');
    if (toggleEl) {
      toggleEl.addEventListener('click', function() {
        var panel = document.getElementById('sr-addr-panel');
        var arrow = document.getElementById('sr-addr-arrow');
        var form = document.getElementById('sr-addr-form');
        if (panel && arrow) {
          if (panel.style.display === 'none') {
            panel.style.display = 'block';
            arrow.style.transform = 'rotate(90deg)';
            f_renderAddressList(SRCartCtrl.getAddresses(), f_getCurrentMid());
          } else {
            panel.style.display = 'none';
            arrow.style.transform = 'rotate(0deg)';
            if (form) form.style.display = 'none';
          }
        }
      });
    }

    // 新建地址按钮
    var newBtn = document.getElementById('sr-addr-new-btn');
    if (newBtn) {
      newBtn.addEventListener('click', function() {
        f_showAddressForm(null);
      });
      newBtn.addEventListener('mouseenter', function() {
        this.style.borderColor = '#451A00';
        this.style.color = '#451A00';
        this.style.background = 'rgba(69,26,0,0.02)';
      });
      newBtn.addEventListener('mouseleave', function() {
        this.style.borderColor = '#c4a882';
        this.style.color = '#8B7355';
        this.style.background = 'transparent';
      });
    }

    // 表单关闭
    var closeBtn = document.getElementById('sr-form-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        document.getElementById('sr-addr-form').style.display = 'none';
      });
    }
    var cancelBtn = document.getElementById('sr_addr_cancel');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', function() {
        document.getElementById('sr-addr-form').style.display = 'none';
      });
    }

    // 保存地址
    var saveEl = document.getElementById('sr_addr_save');
    if (saveEl) {
      saveEl.addEventListener('click', function() {
        var addr = {
          first_name: document.getElementById('sr_addr_first').value.trim(),
          last_name: document.getElementById('sr_addr_last').value.trim(),
          address1: document.getElementById('sr_addr_line1').value.trim(),
          address2: document.getElementById('sr_addr_line2').value.trim(),
          city: document.getElementById('sr_addr_city').value.trim(),
          state: document.getElementById('sr_addr_state').value.trim(),
          zip: document.getElementById('sr_addr_zip').value.trim(),
          phone: document.getElementById('sr_addr_phone').value.trim(),
          country: document.getElementById('sr_addr_country').value
        };
        if (!addr.first_name || !addr.last_name || !addr.address1 || !addr.city || !addr.zip) {
          window.SRModal.error('Missing information', 'Please fill in name, address, city, and ZIP code.');
          return;
        }

        var isDefault = document.getElementById('sr_addr_default').checked;
        var editingId = document.getElementById('sr_addr_save').getAttribute('data-edit-id') || '';
        if (editingId) addr.id = editingId;

        // 写入 localStorage（通过 SRCartCtrl）
        var addrs = SRCartCtrl.getAddresses();
        var existingIdx = -1;
        for (var ii = 0; ii < addrs.length; ii++) {
          var a = addrs[ii];
          if (a.first_name === addr.first_name && a.last_name === addr.last_name &&
              a.address1 === addr.address1 && a.city === addr.city && a.zip === addr.zip) {
            existingIdx = ii;
            break;
          }
        }
        if (existingIdx >= 0) {
          addrs[existingIdx] = addr;
          if (isDefault) SRCartCtrl.setDefaultIdx(existingIdx);
        } else {
          addrs.push(addr);
          if (isDefault) SRCartCtrl.setDefaultIdx(addrs.length - 1);
        }
        SRCartCtrl.saveAddresses(addrs);

        f_updateSummary(addr);
        document.getElementById('sr-addr-form').style.display = 'none';
        document.getElementById('sr_addr_save').removeAttribute('data-edit-id');
        var syncStatus = document.getElementById('sr-addr-sync-status');
        if (syncStatus) {
          syncStatus.textContent = 'Saved locally';
          setTimeout(function() { syncStatus.textContent = ''; }, 2000);
        }
      });
    }

    // 填充已保存地址到表单（首次注入时）
    if (saved) {
      f_fillFormFields(saved);
    }

    // 设置邮箱/手机输入处理器
    f_setupContactInputHandler();

    // 从 localStorage 加载地址并更新摘要
    var localAddrs = SRCartCtrl.getAddresses();
    if (localAddrs.length > 0) {
      var defAddr = null;
      for (var di = 0; di < localAddrs.length; di++) {
        if (localAddrs[di].is_default) { defAddr = localAddrs[di]; break; }
      }
      if (!defAddr) defAddr = localAddrs[0];
      if (defAddr) {
        f_updateSummary(defAddr);
        f_fillFormFields(defAddr);
        // 更新 badge
        var badge = document.getElementById('sr-addr-default-badge');
        if (defAddr && !badge) {
          var toggle = document.getElementById('sr-addr-toggle');
          if (toggle) {
            var b = document.createElement('span');
            b.id = 'sr-addr-default-badge';
            b.style.cssText = 'font-size:10px;background:#451A00;color:#fff;padding:2px 6px;border-radius:3px;letter-spacing:.5px';
            b.textContent = 'DEFAULT';
            toggle.appendChild(b);
          }
        }
      }
    }
  }

  function f_interceptCheckout() {
    var btns = document.querySelectorAll('button[name="checkout"]');
    for (var b = 0; b < btns.length; b++) {
      var btn = btns[b];
      if (btn.dataset.srIntercepted) continue;
      btn.dataset.srIntercepted = 'true';

      btn.addEventListener('click', function(e) {
        if (SRController.isMember()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = '/checkout';
        }
      }, true);
    }
  }

  function f_injectAllIntoDrawer() {
    var bottom = document.querySelector('.t4s-drawer__bottom');
    if (!bottom) return false;

    var hasCheckout = bottom.querySelector('button[name="checkout"]');
    var hasSubtotal = false;
    var children = bottom.children;
    for (var i = 0; i < children.length; i++) {
      var text = (children[i].textContent || '').trim();
      if (/subtotal/i.test(text) && /\$[\d,.]+/.test(text)) {
        hasSubtotal = true;
        break;
      }
    }

    if (!hasCheckout && !hasSubtotal) return false;

    // 单向同步: SRController → 购买域
    SRCartCtrl.syncCustomerFromController();

    // Step 1: 注入 SR 元素
    f_safe(function() { f_injectAddressSection(bottom); });
    f_safe(function() { f_injectSRToolPanel(bottom); });
    f_safe(function() { f_injectContinueShopping(bottom); });
    f_safe(function() { f_createQuickPayButton(bottom); });
    f_safe(function() { f_updateCartUI(); });
    f_safe(function() { f_interceptCheckout(); });

    // 抽屉内禁用回车键
    bottom.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }, true);

    // Step 2: 标记 SR 元素已就绪
    srElementsReady = true;

    // Step 3: 执行全覆盖隐藏
    f_safe(f_takeoverDrawerBottom);

    // Step 4: 延迟再执行一次
    setTimeout(function() { f_safe(f_takeoverDrawerBottom); }, 300);
    setTimeout(function() { f_safe(f_takeoverDrawerBottom); }, 800);

    // Step 5: 注入完成后强制刷新一次 UI
    setTimeout(function() { f_safe(f_updateCartUI); }, 100);
    setTimeout(function() { f_safe(f_updateCartUI); }, 600);

    return true;
  }

  // ============================================================
  // M9. Quick Pay 结算
  // ============================================================

  // f_handleQuickPay — 核心修复：统一走 handleDrawerClose 流程
  function f_handleQuickPay() {
    var btn = document.getElementById('sr-quick-pay-btn');
    if (!btn) return;

    btn.disabled = true;
    btn.innerHTML = 'Processing...';

    var memberData = SRController.get();
    var customer = SRCartCtrl.getCustomer();
    var originalEmail = (customer && customer.email) || memberData.email || '';

    // 统一走 handleDrawerClose 流程（含 email 变更弹窗）
    SRCartCtrl.handleDrawerClose({
      onEmailChanged: function(prevEmail, newEmail) {
        // v8.1: 统一走 processEmailInput
        return SRController.processEmailInput(newEmail, { writeToLocalStorage: true })
          .then(function() {
            return newEmail;
          })
          .catch(function(err) {
            if (err && err.message === 'REQUIRES_CONFIRMATION') {
              return f_showEmailMismatchModal(newEmail, prevEmail);
            }
            console.error('[SR v8.1] handleQuickPay processEmailInput error:', err);
            return false;
          });
      }
    }).then(function(resolvedEmail) {
      var useEmail = resolvedEmail || originalEmail;

      if (!useEmail) {
        f_showRequiredFieldsModal();
        f_resetQuickPayBtn();
        return;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(useEmail)) {
        window.SRModal.error('Invalid email', 'Please enter a valid email address.');
        f_resetQuickPayBtn();
        return;
      }

      if (!SRCartCtrl.getCustomer()) {
        f_getCartData().then(function(cart) {
          if (!cart.items || cart.items.length === 0) {
            window.SRModal.error('Cart is empty', 'Please add items to your cart before checking out.');
            f_resetQuickPayBtn();
            return;
          }
          SRCartCtrl.createPurchaseDomain(cart);
          f_proceedWithQuickPay(btn, useEmail);
        });
        return;
      }
      f_proceedWithQuickPay(btn, useEmail);
    });
  }

  function f_proceedWithQuickPay(btn, useEmail) {
    f_getCartData().then(function(cart) {
      if (!cart.items || cart.items.length === 0) {
        window.SRModal.error('Cart is empty', 'Please add items to your cart before checking out.');
        f_resetQuickPayBtn(); return;
      }

      SRCartCtrl.syncProductsFromCart(cart);

      var isMember = SRController.isMember();
      var memberData = SRController.get();
      var coupon = SRCartCtrl.getCoupon();
      var dr = SRCartCtrl.calculateDiscount(isMember, coupon.rate);
      var products = SRCartCtrl.getProducts();

      var form = document.createElement('form');
      form.method = 'POST';
      form.action = 'https://www.paypal.com/cgi-bin/webscr';
      form.style.display = 'none';

      function addField(name, value) {
        var input = document.createElement('input');
        input.type = 'hidden'; input.name = name; input.value = value;
        form.appendChild(input);
      }

      addField('cmd', '_cart');
      addField('upload', '1');
      addField('business', SRCartCtrl.PAYPAL_EMAIL);
      addField('currency_code', cart.currency || 'USD');
      if (useEmail) addField('email', useEmail);
      if (memberData.first_name) addField('first_name', memberData.first_name);
      if (memberData.last_name) addField('last_name', memberData.last_name);

      var totalDiscounted = 0;
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        var idx = i + 1;
        var finalPrice = Math.round(p.unitPrice * (1 - dr.discountRate));
        var itemName = p.title;
        if (p.variantTitle) itemName += ' - ' + p.variantTitle;
        addField('item_name_' + idx, itemName);
        addField('amount_' + idx, f_formatPrice(finalPrice));
        addField('quantity_' + idx, p.quantity);
        totalDiscounted += finalPrice * p.quantity;
      }

      var discountInfo = [];
      if (dr.discountRate > 0) discountInfo.push(dr.formula);
      if (cart.total_discount > 0) discountInfo.push('Total Discount: ' + f_formatPrice(cart.total_discount));

      var addr = SRCartCtrl.getSavedAddress();
      var shippingAddr = addr ? {
        firstName: addr.first_name || '',
        lastName: addr.last_name || '',
        address1: addr.address1 || '',
        address2: addr.address2 || '',
        city: addr.city || '',
        province: addr.state || '',
        country: addr.country || 'US',
        zip: addr.zip || '',
        phone: addr.phone || ''
      } : null;

      var orderData = {
        email: useEmail || '',
        mid: memberData.mid || '',
        first_name: memberData.first_name || '',
        last_name: memberData.last_name || '',
        is_member: isMember,
        discount_info: discountInfo.length > 0 ? discountInfo.join(' + ') : '',
        discount_composition: dr.discountRate > 0 ? {
          composition: (function() {
            var comp = [];
            if (isMember) comp.push({ type: 'member', desc: 'Member 10% off', rate: 0.10 });
            if (coupon.rate > 0) comp.push({ type: 'coupon', code: coupon.code, desc: 'Coupon ' + Math.round(coupon.rate * 100) + '% off', rate: coupon.rate });
            return comp;
          })(),
          stacked_rate: dr.discountRate,
          effective_price_pct: 1 - dr.discountRate
        } : null,
        note: (document.getElementById('sr_order_note') || {}).value || '',
        subtotal: cart.total_price / 100,
        discount_amount: cart.total_discount / 100,
        total: totalDiscounted / 100,
        items: products.map(function(p) {
          var finalP = Math.round(p.unitPrice * (1 - dr.discountRate));
          var t = p.title;
          if (p.variantTitle) t += ' - ' + p.variantTitle;
          return {
            title: t,
            quantity: p.quantity,
            price: f_formatPrice(finalP),
            original_unit_price: f_formatPrice(p.unitPrice),
            variant_id: p.variantId || null
          };
        }),
        shipping_address: shippingAddr
      };

      var shippingCost = (cart.total_price - totalDiscounted);
      if (shippingCost > 0) {
        orderData.shipping_line = {
          title: 'Shipping',
          price: f_formatPrice(shippingCost)
        };
      }

      fetch(SRCartCtrl.WORKER_URL + '/api/order/snapshot', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orderData)
      }).then(function(resp) { return resp.json(); })
        .then(function(snapResult) {
          if (!snapResult.success || !snapResult.snapshot_id) {
            console.error('[SR v8.1] Snapshot save failed:', snapResult);
            window.SRModal.error('Order save failed', 'Unable to save your order. Please try again.');
            f_resetQuickPayBtn();
            return;
          }

          var snapshotId = snapResult.snapshot_id;
          console.log('[SR v8.1] Order snapshot saved: ' + snapshotId);

          addField('custom', JSON.stringify({
            snapshot_id: snapshotId,
            customer_mid: memberData.mid || '',
            customer_email: useEmail || '',
            customer_first_name: memberData.first_name || '',
            customer_last_name: memberData.last_name || '',
            is_member: isMember
          }));

          addField('notify_url', SRCartCtrl.WORKER_URL + '/api/paypal/ipn?email=' + encodeURIComponent(useEmail || '') + '&mid=' + encodeURIComponent(memberData.mid || ''));

          var addrFields = SRCartCtrl.getShippingFields();
          for (var j = 0; j < addrFields.length; j++) {
            addField(addrFields[j].name, addrFields[j].value);
          }

          var origin = window.location.origin;
          addField('return', origin + '/?src=paypal_return');
          addField('cancel_return', origin + '/?src=paypal_cancel');

          document.body.appendChild(form);
          form.submit();
        })
        .catch(function(err) {
          console.error('[SR v8.1] Snapshot save error:', err);
          window.SRModal.error('Order save failed', 'Unable to save your order. Please try again.');
          f_resetQuickPayBtn();
        });
    }).catch(function(err) {
      console.error('[SR v8.1] QuickPay error:', err);
      window.SRModal.error('Something went wrong', (err && err.message) ? err.message : 'Please try again.');
      f_resetQuickPayBtn();
    });
  }

  function f_resetQuickPayBtn() {
    var btn = document.getElementById('sr-quick-pay-btn');
    if (btn) {
      btn.disabled = false;
      btn.innerHTML = 'Quick Pay';
    }
  }

  // ============================================================
  // 事件响应
  // ============================================================

  function f_onMemberChanged(e) {
    if (!e.detail) return;

    // 统一同步 SRController → 购买域
    SRCartCtrl.syncCustomerFromController();

    // 如果失去会员状态，清除 coupon
    if (!SRController.isMember()) {
      var coupon = SRCartCtrl.getCoupon();
      if (coupon.code || coupon.rate) {
        SRCartCtrl.clearCoupon();
        f_safe(f_updateCartUI);
        return;
      }
    }

    f_safe(f_updateCartUI);
  }

  function f_onVisibilityChange() {
    if (!document.hidden && SRCartCtrl.getCustomer()) {
      SRCartCtrl.syncCustomerFromController();
      srElementsReady = false;
      f_safe(f_injectAllIntoDrawer);
    }
  }

  function f_onPageShow(e) {
    if (e.persisted) {
      console.log('[SR v8.1] Page restored from bfcache, resetting state');
      var btn = document.getElementById('sr-quick-pay-btn');
      if (btn && btn.disabled) {
        btn.disabled = false;
        btn.innerHTML = 'Quick Pay';
      }
      srElementsReady = false;
      f_safe(f_injectAllIntoDrawer);
    }
  }

  function f_handlePayPalReturn() {
    var params = new URLSearchParams(window.location.search);
    var src = params.get('src');
    if (src === 'paypal_return' || src === 'paypal_cancel') {
      console.log('[SR v8.1] PayPal return detected (' + src + '), keeping purchase domain alive');
      if (window.history && window.history.replaceState) {
        var cleanUrl = window.location.pathname + window.location.hash;
        window.history.replaceState({}, document.title, cleanUrl);
      }
    }
  }

  // ============================================================
  // 启动
  // ============================================================

  if (document.readyState !== 'loading') {
    f_init();
  } else {
    document.addEventListener('DOMContentLoaded', f_init);
  }

  // ============================================================
  // 调试接口
  // ============================================================

  window.SR_QUICK_PAY = {
    getState: function() {
      var memberData = SRController.get();
      var coupon = SRCartCtrl.getCoupon();
      return {
        member: Object.assign({}, memberData, { isMember: SRController.isMember() }),
        purchaseCustomer: SRCartCtrl.getCustomer(),
        purchaseProducts: SRCartCtrl.getProducts(),
        coupon: coupon,
        purchaseDomainExists: !!SRCartCtrl.getCustomer()
      };
    }
  };

})();
